/* eslint-disable */
import React from 'react';
import {
    Create,
    Loading,
    useGetList,
} from 'react-admin';
import { AssociateCourseInputs } from './AssociateCourseInputs';

export const AssociateCourseCreate = (props) => {
    const { data, isLoading, error } = useGetList('Status', {
        filter: { q: 'In Development' },
    });

    if (isLoading) {
        return <Loading />;
    }

    if (error) {
        console.log(`Error fetching the 'In Development' status : ${error}`);
    }

    let defaultValues = null;
    if (data && data.length > 0) {
        defaultValues = { statusId: data[0].id };
    }

    return (
        <Create {...props} redirect="edit">
            <AssociateCourseInputs
                {...props}
                defaultValues={defaultValues}
                create={true}
            />
        </Create>
    );
};
